export const isSendingEmailSelector = (state) => state.email.isSending;
export const errorEmailSelector = (state) => state.email.error;
export const didSendEmailSelector = (state) => state.email.didSendEmail;
